import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import makeStyles from "@mui/styles/makeStyles";
import React, { useState } from "react";
import { useCurrentWidth } from "react-socks";
import { ExtendedComment } from "../../../types/comments";
import { CompanyFile, DashboardDocument, DashboardScreenshot, DashboardSelection, } from "../../../types/files";
import { mobileWidth } from "../../App";
import TagModes from "../../atoms/TagModes";

const useStyles = makeStyles((theme) => ({
    dashboardTagsContainer: {
        margin: 10,
        borderRadius: 8,
        backgroundColor: theme.palette.common.white,
        height: 'calc(100% - 60px)'
    },
    dashboardTagsContainerMobile: {
        padding: "20px 5px 10px 5px",
        marginBottom: 70,
        overflowY: 'auto',
    },
    dashboardTagsBoxItems: {
        borderRadius: 10,
        padding: '0 5px',
        margin: '0 5px',
        height: 'calc(100% - 53px)',
        overflowY: 'auto',
        "&::-webkit-scrollbar": {
            width: 5,
        },
        "&::-webkit-scrollbar-track": {
            background: theme.palette.common.white,
        },
        "&::-webkit-scrollbar-thumb": {
            background: grey[400],
            borderRadius: 4,
        },
    },
    dashboardTagsBoxItemsMobile: {
        border: `1px solid ${grey[400]}`,
        borderRadius: 10,
        padding: 5,
        margin: 0
    },
    dashboardTagsItems: {
    },
    mention: {
        fontWeight: 'bold !important',
        color: theme.palette.secondary.main,
        position: "relative",
        zIndex: 1,
        textShadow: "1px 1px 1px white, 1px -1px 1px white, -1px 1px 1px white, -1px -1px 1px white",
        pointerEvents: "none"
    },
    commentHeading: {
        marginBottom: 5,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline'
    },
    commentText: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        lineClamp: 1,
        lineHeight: "1.4",
        wordBreak: "break-word"
    },
    leftCommentHeading: {
        color: theme.palette.primary.main,
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 100px)'
    },
    rightCommentHeading: {
        display: 'flex',
        flexDirection: 'row',
        width: 100,
        whiteSpace: 'nowrap',
        justifyContent: 'end'
    },
    userHeading: {
        fontSize: 14,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineClamp: 1,
        color: theme.palette.primary.light,
        padding: '5px 5px 0px 5px',
        whiteSpace: 'nowrap',
    },
    pageTitleHeading: {
        fontSize: 14,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineClamp: 1,
        padding: 0,
        whiteSpace: 'nowrap',
        marginLeft: 28,
        marginBottom: 4,
        color: '#999999'
    },
    infoHeading: {
        marginLeft: 5,
        fontSize: 12,
        textDecoration: 'none',
        color: theme.palette.text.primary,
        fontWeight: 'bold',
        alignSelf: 'center'
    },
    tagCard: {
        paddingBottom: 5,
        '&:hover': {
            boxShadow: `inset 0px -3px 3px -3px ${theme.palette.primary.light} !important`,
        },
    },
    bullet: {
        display: "inline-block",
        width: 20,
        height: 20,
        fontSize: 12,
        background: theme.palette.primary.light,
        color: "#fff",
        borderRadius: "50%",
        textAlign: "center",
        verticalAlign: "middle",
        marginRight: 5
    },
    actionIcon: {
        height: 15,
        width: 15,
    },
    actionIconButton: {
        padding: 4,
    },
}));

const DashboardTags: React.FC<{
    dashboardId?: string,
    dashboardItems: (DashboardDocument | DashboardScreenshot | DashboardSelection)[],
    comments: ExtendedComment[],
    highlightedComments: number[],
    selectedFile?: CompanyFile,
    otherFiles: CompanyFile[],
    preSelectedCommentId?: string,
    setHighlightedComments: (list: number[]) => void,
    onSelectComment: (comment?: ExtendedComment, dashboardElement?: DashboardDocument | DashboardScreenshot | DashboardSelection) => void
    onReplyAdded: (reply: ExtendedComment) => void
}> = ({ selectedFile }) => {
    const classes = useStyles();
    const [selectedTagMode, setSelectedTagMode] = useState('All');

    const currentWidth = useCurrentWidth();
    const isMobile = currentWidth && currentWidth < 9999 ? currentWidth <= mobileWidth : window?.innerWidth <= mobileWidth;

    return (
        <Box className={isMobile ? classes.dashboardTagsContainerMobile : classes.dashboardTagsContainer}>
            {isMobile && <Typography variant="h5" fontWeight="bold" px={5} mx={2} mb={2}>Comments</Typography>}
            <TagModes selectedMode={selectedTagMode} selectedFile={selectedFile} onSelectMode={(mode: string) => setSelectedTagMode(mode)} />
            <Box sx={{ textAlign: 'center' }}><Typography>No comments yet.</Typography></Box>
        </Box>
    )
};

export default DashboardTags;
